import { ArrowRight, Bell } from 'lucide-react';
import { Link } from 'react-router';

import { Badge, Button } from '@workspace/shadcn';

import { CourseMeta, type CourseCardData } from './course-meta.tsx';
import { useModals } from './modals.tsx';

export function CourseCard({ course }: { course: CourseCardData }) {
  const { open } = useModals();

  return (
    <article className="border-foreground/10 bg-card group relative flex h-full flex-col overflow-hidden rounded-2xl border transition duration-200 hover:shadow-xl">
      <div className="relative aspect-16/10 w-full shrink-0 overflow-hidden rounded-t-2xl">
        <img
          src={course.imageUrl}
          alt={course.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-110"
        />
        {course.category && (
          <div className="absolute start-4 top-4 z-10">
            <Badge className="bg-foreground text-background hover:bg-primary/20 transition-colors">
              {course.category}
            </Badge>
          </div>
        )}
      </div>

      <div className="flex grow flex-col p-6">
        <h3 className="text-foreground mb-2 text-xl font-bold">
          {course.title}
        </h3>
        <p className="text-muted-foreground mb-4 line-clamp-2 text-sm">
          {course.oneLiner}
        </p>

        <CourseMeta course={course} />

        <div className="mt-auto">
          {course.comingSoon ? (
            <Button
              onClick={() => open('course')}
              className="bg-foreground/95 text-background hover:bg-foreground w-full gap-3"
            >
              Notify Me
              <Bell className="ease-out-expo size-4 transition-transform group-hover:scale-125" />
            </Button>
          ) : (
            <Link to={`/courses/${course.slug}`} className="block w-full">
              <Button className="bg-foreground/95 text-background hover:bg-foreground w-full gap-1">
                Learn More
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Button>
            </Link>
          )}
        </div>
      </div>
    </article>
  );
}
